import $ from 'jquery';

class ContentBlocker {
    constructor() {
        this.$body = $('body');
        this.pageOffset = 0;
        this._isBlocked = false;
        this.sources = {};
    }

    block(source) {
        this.sources[source] = true;
        if (!this._isBlocked) {
            this.pageOffset = window.pageYOffset;
            if (this.pageOffset > 0) this.$body.addClass('is-blocked-sticky-nav');
            this.$body.addClass('is-blocked');
            this.$body.css('top', -this.pageOffset);
            this._isBlocked = true;
        }
    }

    unblock(source) {
        this.sources[source] = false;
        if (this.isFree() && this._isBlocked) {
            this.$body.css('top', 'initial');
            this.$body.removeClass('is-blocked').removeClass('is-blocked-sticky-nav');
            window.scrollTo(0, this.pageOffset);
            this._isBlocked = false;
        }
    }

    isBlocked(source) {
        return this.sources[source] === true;
    }

    isFree() {
        return Object.keys(this.sources).every(key => this.sources[key] === false);
    }
}

const instance = new ContentBlocker();

export default instance;



// WEBPACK FOOTER //
// ./app/general/js/content-blocker.js